import React from "react";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "mdbreact";
/**
 *  This component is supporting component of About NHP Component
 *
 */

export default class AboutNHPModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.title}
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody>
            <p style={{ textAlign: "justify" }}>{this.props.info}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

// import React, { Component } from 'react';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//
//
// export default class About extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       modal: false
//     };
//
//     //this.toggle = this.toggle.bind(this);
//   }
//
//   toggle = () => {
//     this.setState({
//       modal: !this.state.modal
//     });
//   }
//   render(){
//     return (
//       <div>
//         <style>
//           {
//             `
//               /* Smartphones (portrait) ----------- */
//               @media only screen and (max-width : 700px) {
//                 button{
//                   width:100%;
//                   overflow: hidden;
//                   text-overflow: ellipsis;
//                   white-space: nowrap;
//                 }
//
//               }`
//           }
//         </style>
//         <Button className= "btn btn-outline-primary" onClick={this.toggle}>{this.props.title}</Button>
//         <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
//           <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
//
//           <ModalBody>
//             <p style={{textAlign:"justify"}}>{this.props.info}</p>
//           </ModalBody>
//
//         </Modal>
//
//       </div>
//     );
//   }
// }
